import { ModelInterface } from '../models/util';

export class StorageEngineField {
  defaultValue: any;

  constructor(defaultValue?: any, protected modelClass?: ModelInterface) {
    this.defaultValue = defaultValue;
  }

  toFront(value: any): any {
    if (this.modelClass) {
      return this.modelClass.toFront(value);
    }
    return value;
  }

  toBack(value: any): any {
    if (this.modelClass) {
      return this.modelClass.toBack(value);
    }
    return value;
  }
}

export abstract class StorageEngine {
  constructor(protected name: string, protected fields: {[key: string]: StorageEngineField}) {
  }

  addField(key: string, field: StorageEngineField): void {
    this.fields[key] = field;
  }

  save(key: string, value: any): void {
    if (!this.fields[key]) {
      return;
    }
    this.setItem(`${this.name}_${key}`, this.fields[key].toBack(value));
  }

  get(key: string): any {
    if (!this.fields[key]) {
      return;
    }
    let value = this.getItem(`${this.name}_${key}`);
    if (value === null) {
      value = this.fields[key].defaultValue;
    }
    if (value === null || value === undefined) {
      return value;
    }
    return this.fields[key].toFront(value);
  }

  clear(): void {
    for (const field of Object.keys(this.fields)) {
      this.removeItem(field);
    }
  }

  protected getItem(key: string): any {
    throw new Error(`Function getItem for store engine ${typeof this} not implemented`);
  }

  protected setItem(key: string, value: any): any {
    throw new Error(`Function setItem for store engine ${typeof this} not implemented`);
  }

  protected removeItem(key: string): void {
    throw new Error(`Function deleteItem for store engine ${typeof this} not implemented`);
  }
}
